import React, {useEffect, useState} from 'react';
import Select from "react-select";
import {
    OBJECT_SPECIALS,
    JOB_SEND_REQUESTS,
    CommonUseFields,
    LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode, OnlyAdminViewFields
} from "@app/constants/Common";
import {
    requestRejectNotify,
    requestRemoveInputOfOtherUser,
    requestReportWrongInput,
    requestReportWrongINput
} from "@app/services/UserService";
import {toast} from "react-toastify";
import {Messages} from "@app/constants/Messages";
import {arrayToString, stringToArray} from "@app/utils/CommonUtils";
import ShowAllUserInputModal from "@pages/candidate/commonview/ShowAllUserInputModal";

const AllUserInputField = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showMoreInfo, setShowMoreInfo] = useState(false);


    const {arrInfo, field, canDelete = true} = props

    let fieldItem = CommonUseFields[field]
    if (!fieldItem && userLoginInfo.is_superuser) {
        fieldItem = OnlyAdminViewFields[field]
    }

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])


    const reportWrongInput = (data) => {
        requestReportWrongInput(data).then((res) => {
            toast.success(Messages.sendReportWrongInputSuccess)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
            toast.error(Messages.sendReportWrongInputFailed)
        }).finally(() => {
        });
    }

    const onRemoveInput = (values, removeItemIndex, userInput, candidateId, fieldKey) => {
        let text = `Bạn chắc chắn muốn xóa thông tin [${values[removeItemIndex]}]?`;
        if (window.confirm(text) === true) {
            const valueList = [...values]
            valueList.splice(removeItemIndex, 1)
            // Remove
            let requestBody = {
                candidate_id: candidateId,
                user_input_id: userInput,
                field_key: fieldKey,
                field_value: arrayToString(valueList),
            }

            requestRemoveInputOfOtherUser(requestBody).then((res) => {
                toast.success(Messages.processSuccess)
            }).catch((error) => {
                console.log(`Error:${JSON.stringify(error)}`);
                toast.error(Messages.haveErrorInProcess)
            }).finally(() => {
            });
        }
    }

    const onShowMoreInput = () => {
        setShowMoreInfo(true)
    }

    const onReportWrongInput = (item, fieldKey) => {
        const itemValue = item[fieldKey]
        let newValue = prompt(` Ứng viên: ${item.candidate}
        \n Trường thông tin: ${fieldItem.title}
        \n Giá trị: ${itemValue}
        \n Người nhập: ${item.user_input}
        \n Dữ liệu đúng là (Trường hợp nhiều giá trị, hãy nhập cách nhau bởi dấu ';'):`, "");
        // if (newValue === null || newValue === "") {
        //     if (newValue === "") {
        //         alert("Vui lòng nhập giá trị mà bạn cho là đúng.")
        //     }
        //     return
        // }

        if (newValue === null) {
            // Trường hợp nhấn cancel
            return;
        }

        if (newValue.trim().toLowerCase() === itemValue.toLowerCase()) {
            alert("Giá trị bạn nhập giống với giá trị đã input trên phần mềm.")
            return;
        }
        let requestData = {
            candidate_id: item.candidate,
            field_key: fieldKey,
            current_value: itemValue,
            new_value: newValue,
            user_input: item.user_input,
            user_input_id: item.created_user,
        }

        reportWrongInput(requestData)
    }

    const displayValues = (fullMode) => {
        if (arrInfo && arrInfo.length > 0) {
            return arrInfo.map((item, index) => {
                const itemValue = item[field]
                if (item.created_user !== userLoginInfo.id && itemValue) {
                    const values = stringToArray(itemValue)
                    return values.map((value, valueIndex) => {
                        return <div key={`allUserinputfield_display_values_item_${index}_${valueIndex}`} className={!fullMode ? "text-truncate" : ""}>
                            <a href="javascript:void(0)"
                               className={'text-info mr-1'}
                               style={{borderBottom: '2px solid', cursor: 'pointer'}}
                               data-toggle="dropdown"
                               title={`Người input: ${item.user_input}; Ngày NL mới nhất: ${item.updated_date_time}`}
                            >
                                {fieldItem.options && fieldItem.options.length > 0 ? fieldItem.options[value] : value}
                                {index === arrInfo.length - 1 ? "" : " "}
                            </a>
                            <div className="dropdown-menu p-0" role="menu">
                                {!fullMode &&
                                    <a href="javascript:void(0)"
                                       className={'dropdown-item'}
                                       onClick={() => onShowMoreInput(item, field)}>
                                        Xem thêm
                                    </a>
                                }
                                {!userLoginInfo.is_superuser &&
                                    <a href="javascript:void(0)"
                                       className={'dropdown-item'}
                                       onClick={() => onReportWrongInput(item, field)}>
                                        Report NL sai
                                    </a>
                                }
                                {userLoginInfo.is_superuser && canDelete &&
                                    <a href="javascript:void(0)"
                                       className={'dropdown-item'}
                                       onClick={() => onRemoveInput(values, valueIndex, item.created_user, item.candidate, field)}>
                                        Xóa
                                    </a>
                                }
                            </div>
                        </div>
                    })
                }
                return ""
            })
        }
        return ""
    }

    return <>
        {fieldItem && arrInfo && arrInfo.length > 0 &&
        <>
            <div className={'w-100 mb-1 ml-1 row'}>
                {displayValues()}
                {showMoreInfo &&
                <ShowAllUserInputModal isShow={showMoreInfo} displayInfo={() => displayValues(true)}
                                       onClose={() => {setShowMoreInfo(false)}} />
                }
            </div>

        </>
        }
    </>
};

export default AllUserInputField;
